var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolicitacoes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 576",
    width: 576,
    height: 576,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "solicitacoes-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #000000 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M214.5 522.98L214.5 559.13C214.5 568.45 206.94 576 197.63 576L16.88 576C7.55 576 0 568.45 0 559.13L0 522.98C0 481.52 22.97 448.27 52.57 430.66C31.6 414.33 18.07 388.87 18.07 360.3C18.07 311.13 58.08 271.13 107.25 271.13C156.42 271.13 196.43 311.13 196.43 360.3C196.43 388.87 182.9 414.33 161.93 430.66C191.53 448.27 214.5 481.53 214.5 522.98ZM107.25 415.73C137.81 415.73 162.68 390.86 162.68 360.3C162.68 329.74 137.81 304.88 107.25 304.88C76.69 304.88 51.82 329.74 51.82 360.3C51.82 390.86 76.69 415.73 107.25 415.73ZM180.75 542.25L180.75 522.98C180.75 482.32 147.85 449.48 107.25 449.48C66.59 449.48 33.75 482.38 33.75 522.98L33.75 542.25L180.75 542.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M504.9 0C544.23 0 576 31.83 576 71.1L576 288C576 327.33 544.17 359.1 504.9 359.1L311.7 359.1L243.9 409.95C232.73 418.32 216.9 410.25 216.9 396.45L216.9 71.1C216.9 31.77 248.73 0 288 0L504.9 0ZM542.25 71.1C542.25 50.44 525.55 33.75 504.9 33.75L288 33.75C267.35 33.75 250.65 50.45 250.65 71.1L250.65 362.7L295.95 328.72C298.87 326.54 302.42 325.35 306.07 325.35L504.9 325.35C525.56 325.35 542.25 308.65 542.25 288L542.25 71.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M486.83 90.37L306.07 90.37C296.75 90.37 289.2 97.93 289.2 107.25C289.2 116.57 296.75 124.12 306.07 124.12L486.83 124.12C496.14 124.12 503.7 116.57 503.7 107.25C503.7 97.93 496.15 90.37 486.83 90.37Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M486.83 162.68L306.07 162.68C296.75 162.68 289.2 170.23 289.2 179.55C289.2 188.87 296.75 196.43 306.07 196.43L486.83 196.43C496.14 196.43 503.7 188.87 503.7 179.55C503.7 170.23 496.15 162.68 486.83 162.68Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M396.45 234.98L306.07 234.98C296.75 234.98 289.2 242.53 289.2 251.85C289.2 261.17 296.75 268.73 306.07 268.73L396.45 268.73C405.77 268.73 413.32 261.17 413.32 251.85C413.32 242.53 405.77 234.98 396.45 234.98L396.45 234.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolicitacoes);
export default __webpack_public_path__ + "static/media/solicitacoes.8459d1e8ffab9acf8a02cb0488670257.svg";
export { ForwardRef as ReactComponent };